export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="icon24/gift">
                <path id="Rectangle 50652" d="M4 10H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V10Z" fill="#FF6648" />
                <rect id="Rectangle 50653" width="20" height="4" rx="1" transform="matrix(1 0 0 -1 2 10)" fill="#F42B1C" />
                <path
                    id="Vector"
                    d="M17.3113 3.54267L18 4.83304L13.2121 6L13 5.7171L15.9379 3.21451C16.045 3.12301 16.166 3.05884 16.2935 3.02578C16.4211 2.99272 16.5527 2.99144 16.6807 3.02202C16.8087 3.0526 16.9304 3.11442 17.0387 3.20383C17.147 3.29325 17.2397 3.40845 17.3113 3.54267Z"
                    fill="#F7A614"
                />
                <path
                    id="Vector_2"
                    d="M7.55211 3.54199L7 4.83272L10.8303 6L11 5.71702L8.64968 3.21373C8.56401 3.12248 8.46736 3.05852 8.36543 3.02561C8.26349 2.9927 8.15832 2.9915 8.05608 3.02207C7.95383 3.05265 7.85659 3.11439 7.77005 3.20367C7.6835 3.29296 7.60941 3.40798 7.55211 3.54199Z"
                    fill="#F7A614"
                />
                <path
                    id="Vector_3"
                    d="M19.5311 4.73343L20 6H14V4.91919L18.3192 4.02118C18.5668 3.96972 18.8234 4.01271 19.0446 4.14274C19.2659 4.27277 19.4379 4.48168 19.5311 4.73343Z"
                    fill="#FFC627"
                />
                <path
                    id="Vector_4"
                    d="M4.46892 4.73336L4 6H10V4.91913L5.6804 4.02108C5.43285 3.96976 5.17639 4.01283 4.95524 4.14286C4.73408 4.27288 4.56209 4.48172 4.46892 4.73336Z"
                    fill="#FFC627"
                />
                <path
                    id="Vector_5"
                    d="M9.76313 9.95162H14.3697V21H9.76313V9.95162ZM14.4164 5.79503H9.67285L10.1324 3.91543C10.1644 3.7847 10.2393 3.66848 10.3451 3.58541C10.451 3.50233 10.5817 3.45721 10.7163 3.45728H13.3733C13.5078 3.45721 13.6385 3.50233 13.7444 3.58541C13.8503 3.66848 13.9252 3.7847 13.9571 3.91543L14.4164 5.79503Z"
                    fill="#FFC627"
                />
                <path
                    id="Vector_6"
                    d="M9.61547 5.53528H14.498C14.7755 5.53528 14.9142 5.67403 14.9142 5.95153V9.79509C14.9142 10.0726 14.7755 10.2113 14.498 10.2113H9.61547C9.33797 10.2113 9.19922 10.0726 9.19922 9.79509V5.95153C9.19922 5.67403 9.33797 5.53528 9.61547 5.53528Z"
                    fill="#FFB624"
                />
            </g>
        </svg>
    );
}
